import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Select,
  MenuItem,
  FormControl,
  useMediaQuery,
  Card,
  CardContent,
  Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SthanickLogo from "../../assets/images/Home_page_image/Login/LoginLogo.png"; 

const CreateAccount = ({onNext}) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:767px)"); 
  const [countryCode, setCountryCode] = useState("+91");
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      backgroundColor: "#f5f5f5",
      padding: isMobile ? "15px" : "40px",
      "@media (max-width: 600px)": {
        height: "auto",
      },
    }}
  >
    <Box
      component="img"
      src={SthanickLogo}
      alt="Sthanick Logo"
      sx={{
        width: isMobile ? "150px" : "200px",
        borderRadius: "10px",
        marginBottom: isMobile ? "10px" : "20px",
      }}
    />
  
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "auto",
      }}
    >
      <Card
        sx={{
          width: isMobile ? "100%" : "400px",
          padding: "20px",
          borderRadius: "10px",
          border: "1px solid #ddd",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          backgroundColor: "#fff",
          "@media (max-width: 600px)": {
            padding: "15px",
          },
        }}
      >
        <CardContent>
          <Typography variant="h5" fontWeight="bold" mb={2} textAlign="start">
            Create Your Account
          </Typography>
  
          <Typography fontSize="14px" fontWeight="bold">Your Name</Typography>
          <TextField
            placeholder="First and last name"
            variant="outlined"
            fullWidth
            name="name"
            value={formData.name}
            onChange={handleChange}
            size="small"
            sx={{ marginBottom: "12px", marginTop: "5px" }}
          />
  
  <Typography fontSize="14px" fontWeight="bold">Mobile Number</Typography>
<Box
  sx={{
    display: "flex",
    alignItems: "center",
    marginBottom: "12px",
    marginTop: "10px",
    width: "100%",
  }}
>
  <FormControl
    sx={{
      width: "30%", 
      marginRight: "8px",
      "@media (max-width:600px)": { width: "35%" } 
    }}
    size="small"
  >
    <Select
      value={countryCode}
      onChange={(e) => setCountryCode(e.target.value)}
      displayEmpty
      sx={{
        fontSize: "14px",
        "& .MuiSelect-select": {
          padding: "8px", 
        },
      }}
      renderValue={(selected) => selected || "IN +91"}
    >
      <MenuItem value="+91">IN +91</MenuItem>
      <MenuItem value="+1">US +1</MenuItem>
      <MenuItem value="+44">UK +44</MenuItem>
    </Select>
  </FormControl>

  <TextField
    fullWidth
    variant="outlined"
    placeholder="Enter mobile number"
    size="small"
    sx={{
      "@media (max-width:600px)": { fontSize: "14px", padding: "8px" },
    }}
  />
</Box>

           
  
          <Typography fontSize="14px" fontWeight="bold">Password</Typography>
          <TextField
            placeholder="At least 6 characters"
            type="password"
            variant="outlined"
            fullWidth
            name="password"
            value={formData.password}
            onChange={handleChange}
            size="small"
            sx={{ marginBottom: "5px", marginTop: "5px" }}
          />
          <Typography variant="body2" color="textSecondary" sx={{ marginBottom: "10px" }}>
            Passwords must be at least 6 characters.
          </Typography>
  
          <Typography variant="body2" color="textSecondary" sx={{ marginBottom: "15px" }}>
            To verify your number, we will send you a text message with a temporary code.
            Message and data rates may apply.
          </Typography>
  
          <Button
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: "#e45026",
              color: "white",
              fontWeight: "bold",
              fontSize: isMobile ? "12px" : "14px",
              padding: "10px",
              "&:hover": { backgroundColor: "#e45026" },
            }}
            onClick={onNext}
          >
            Verify Mobile Number
          </Button>
  
          <Typography variant="body2" sx={{ marginTop: "15px", textAlign: "center", fontSize: "14px" }}>
            <strong>Buying for work?</strong> <br />
            <span style={{ color: "#0073C0", cursor: "pointer" }}>Create a free business account</span>
          </Typography>
  
          <Typography variant="body2" sx={{ marginTop: "15px", textAlign: "center", fontSize: "14px" }}>
            Already have an account? <span style={{ color: "#0073C0", cursor: "pointer" }}>Sign in</span>
          </Typography>
  
          <Typography variant="body2" sx={{ marginTop: "15px", fontSize: "12px", textAlign: "center" }}>
            By creating an account or logging in, you agree to Sthanick’s
            <span style={{ color: "#0073C0", cursor: "pointer" }}> Conditions of Use</span> and
            <span style={{ color: "#0073C0", cursor: "pointer" }}> Privacy Policy</span>.
          </Typography>
        </CardContent>
      </Card>
    </Container>
  
    <Box
      sx={{
        mt: 2,
        display: "flex",
        gap: 3,
        "@media (max-width: 600px)": {
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        },
      }}
    >
      <Link href="#">Conditions of Use</Link>
      <Link href="#">Privacy Notice</Link>
      <Link href="#">Help</Link>
    </Box>
  
    <Typography variant="body2" sx={{ mt: 1, color: "#767676" }}>
      © 1996-2024, Sthanick.com, Inc. or its affiliates
    </Typography>
  </Box>
  
  );
};

export default CreateAccount;